import React from "react";
import IconButton from "@mui/material/IconButton";

function CloseGlyph({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.02038 10L0.203161 18.8172C-0.0660055 19.0864 -0.0667421 19.5257 0.203773 19.7962C0.476175 20.0686 0.912606 20.067 1.18278 19.7968L10 10.9796L18.8172 19.7968C19.0864 20.066 19.5257 20.0667 19.7962 19.7962C20.0686 19.5238 20.067 19.0874 19.7968 18.8172L10.9796 10L19.7968 1.1828C20.066 0.9136 20.0667 0.4743 19.7962 0.2038C19.5238 -0.0686 19.0874 -0.067 18.8172 0.2032L10 9.0204L1.18278 0.2032C0.913617 -0.066 0.474289 -0.0667 0.203773 0.2038C-0.068628 0.4762 -0.0670162 0.9126 0.203161 1.1828L9.02038 10Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function ModalCloseButton({ onClick, style, className, size = 40 }) {
  return (
    <IconButton
      onClick={onClick}
      className={className}
      style={{
        position: "absolute",
        top: 0,
        right: 0,
        width: size,
        height: size,
        borderRadius: 0,
        color: "#444444",
        ...style,
      }}
    >
      <CloseGlyph />
    </IconButton>
  );
}
